interface DateRangeBounds {
  start: Date | null
  end: Date | null
}

function formatDay(date: Date): string {
  return date.toLocaleDateString("en-US", { month: "short", day: "numeric" })
}

/**
 * Human label for an applied date range, or null when no bound is set.
 * Toolbar date controls carry it, so the applied range is readable without
 * opening the popover.
 */
export function formatDateRangeLabel(
  dateRange: DateRangeBounds,
): string | null {
  const { start, end } = dateRange

  if (start && end) {
    return `${formatDay(start)} - ${formatDay(end)}`
  }
  if (start) {
    return `From ${formatDay(start)}`
  }
  if (end) {
    return `Until ${formatDay(end)}`
  }
  return null
}
